import { Helmet } from "react-helmet-async";

const Privacy = () => {
  return (
    <main className="container mx-auto py-10 space-y-6">
      <Helmet>
        <title>Privacy Policy — U.S. Height Percentiles</title>
        <meta name="description" content="Privacy policy including advertising and cookies disclosures." />
        <link rel="canonical" href={window.location.origin + "/privacy"} />
      </Helmet>
      <h1>Privacy Policy</h1>
      <p>
        We do not collect personally identifiable information. We may use cookies and device identifiers for
        advertising and analytics purposes. Third-party vendors, including Google, use cookies to serve ads
        based on your prior visits to this and other websites.
      </p>
      <p>
        You can opt out of personalized advertising by visiting <a href="https://www.aboutads.info/choices/">AboutAds</a> or
        <a href="https://adssettings.google.com" rel="nofollow">Google Ads Settings</a>.
      </p>
      <p className="text-sm text-muted-foreground">This site provides informational content only and does not offer medical advice.</p>
    </main>
  );
};

export default Privacy;
